import { yupResolver } from "@hookform/resolvers/yup";
import { Close, Login } from "@mui/icons-material";
import { Alert, Box, Button, Collapse, Grid, IconButton } from "@mui/material";
import { TextInput } from "qubCommon/Inputs";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { getByAmkaAfm } from "util/getAmkaRegistryInfo";
import RegisterStep3 from "./RegisterStep3";
import { useRegisterValidation } from "util/validations/registration-form";
import { useYupValidationResolver } from "hooks/useYupValidationResolver";
import { amkaLogin } from "apis/controllers/auth";
import { createMarkup } from "util/createMarkup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "store/authReducer";
import { storeMenu } from "store/menuReducer";
import { LoadingButton } from "@mui/lab";
import { jwtDecode } from "jwt-decode";

// window.serverData = { data: { afm: "660074100" } };  // only for dev purposes

const RegisterStep2 = () => {
  const [amkaFilled, setAmkaFilled] = useState(false);
  const [loading, setLoading] = useState(false);

  const [data] = useState(window.serverData || {});
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(data);
  let decodedData;
  try {
    decodedData = jwtDecode(data?.data?.token);
  } catch (e) {
    console.log(e);
  }

  const registerValidation = useRegisterValidation();
  const form = useForm();
  const registrationForm = useForm({
    resolver: useYupValidationResolver(registerValidation),
    criteriaMode: "all",
  });

  const onSubmit = async (submitData) => {
    setError("");
    try {
      setLoading(true);
      const res = await amkaLogin({
        AMKA: submitData?.amka,
        AFM: submitData?.afm,
        token: data?.data?.token,
      });
      const { status } = res;
      console.log(res);
      // if (status === "success") {
      //   console.log(res?.data);
      //   console.log(amkaFilled, "amkaFilled");
      //   setAmkaFilled(true);
      // }
      if (status === "error") {
        setError(res?.message);
      } else if (status === "empty") {
        setError("Παρακαλώ συμπληρώστε τα πεδία.");
      } else {
        try {
          dispatch(
            login({
              token: res?.token,
              refreshToken: res?.refreshToken,
              user: res?.user,
              seasonId: res?.season
            })
          );

          dispatch(storeMenu(res?.menu));
          navigate("/applications");
        } catch (e) {
          console.error("Error during login:", e);
          setError("Σφάλμα κατά την είσοδο. Παρακαλώ δοκιμάστε ξανά.");
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  if (!amkaFilled)
    return (
      <div className="applications-container" style={{ minHeight: "70vh" }}>
        <FormProvider {...form}>
          <Box
            container
            sx={{
              padding: "28px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              background: "#fbfcfe",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: 4,
            }}
          >
            <Grid item xs={12} alignSelf="center">
              <h3
                style={{ fontSize: "1.4em", fontWeight: 500, marginBottom: 40 }}
              >
                Το TAXISNET σας πιστοποίησε, εισάγετε τον ΑΜΚΑ σας για είσοδο
              </h3>
              <Collapse in={!!error}>
                <Alert
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setError("");
                      }}
                    >
                      <Close fontSize="inherit" />
                    </IconButton>
                  }
                  variant="filled"
                  severity="error"
                >
                  <div dangerouslySetInnerHTML={createMarkup(error)} />
                </Alert>
              </Collapse>
            </Grid>
            <Grid item xs={12} alignSelf="center">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  padding: "40px",
                }}
              >
                <TextInput
                  name="afm"
                  label="ΑΦΜ"
                  disabled
                  defaultValue={decodedData?.nameid}
                />
                <TextInput name="amka" label="ΑΜΚΑ" />
                <LoadingButton
                  variant="contained"
                  startIcon={<Login />}
                  loading={loading}
                  sx={{ width: "100%", marginTop: 6 }}
                  onClick={form.handleSubmit(onSubmit)}
                >
                  Είσοδος
                </LoadingButton>
              </div>
            </Grid>
          </Box>
        </FormProvider>
      </div>
    );
  return <RegisterStep3 registrationForm={registrationForm} />;
};

export default RegisterStep2;
